import { render, staticRenderFns } from "./DetailProcedure.vue?vue&type=template&id=8800bc86&"
import script from "./DetailProcedure.vue?vue&type=script&lang=js&"
export * from "./DetailProcedure.vue?vue&type=script&lang=js&"
import style0 from "./DetailProcedure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports